import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

import { type ParcelLabResponse } from './ParcelLabTypes'

export const parcelLabAccessorGetParcelLabDeliveredStatus = (
  subOrder: UserSubOrderV2 | UserOrderResponseWithFlagsSubOrdersInner,
  parcelLabData?: ParcelLabResponse,
): boolean => {
  if (!parcelLabData?.header) {
    return false
  }

  const IsParcelLabStatusDelivered =
    parcelLabData.header[0].last_delivery_status.status === 'Delivered'

  const isOrderDelivered = subOrder.status === 'delivered'

  return IsParcelLabStatusDelivered || isOrderDelivered
}
